// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDA2Q6A4MrhgYlJnjaWycO-M6D8ToXRYAM',
    authDomain: 'angularexamples-b69f4.firebaseapp.com',
    databaseURL: 'https://angularexamples-b69f4.firebaseio.com',
    projectId: 'angularexamples-b69f4',
    storageBucket: 'angularexamples-b69f4.appspot.com',
    messagingSenderId: '311456846239',
  },
};
